export const getCommissionsChart = `/core/commission/partner/activities`;
export const getCommissions = `/core/commission/partner`;
export const getCommissionsInsight = `/core/commission/partner/insight`;
